import { 
  db,
  fb,
  googleAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider,
  githubAuthProvider,
} from './firebase';
import crs from 'crypto-random-string';
import { sendSignUpAlert } from './alertsAPI';

export const signIn = async (email, password) => {
  try {
    await fb.auth().signInWithEmailAndPassword(email, password);
  } catch (e) {
    const { code, message } = e;
    console.error('signin', email, code, message);
    throw e;
  }
}

export const signInWithProvider = async (provider) => {
  try {
    switch (provider) {
      case 'google':
        return await fb.auth().signInWithPopup(googleAuthProvider);
      case 'facebook':
        return await fb.auth().signInWithPopup(facebookAuthProvider);
      case 'twitter':
        return await fb.auth().signInWithPopup(twitterAuthProvider);
      case 'github':
        return await fb.auth().signInWithPopup(githubAuthProvider);
      default:
        throw new Error('no provider found');
    }
  } catch (e) {
    const { code, message } = e;
    console.error(`signInWithProvider: ${provider}`, e.email, code, message);
    throw e;
  }
}

export const signOut = async () => {
  await fb.auth().signOut();
}

export const signUp = async (user) => {
  user.favorites = [];
  user.shared = [];
  user.family = '';
  user.role = 'user';
  user.isAccepted = false;
  user.isPending = true;
  const { email } = user;
  const password = crs({ length: 15 });
  const userRecord = await fb.auth().createUserWithEmailAndPassword(email, password);
  fb.auth().sendPasswordResetEmail(email);
  const userID = userRecord.user.uid;
  await db
    .collection('users').doc(userID)
    .set(user);
  sendSignUpAlert({ id: userID, ...user });
}

export const signUpWithProvider = async (user) => {
  user.favorites = [];
  user.shared = [];
  user.family = '';
  user.role = 'user';
  user.isAccepted = false;
  user.isPending = true;
  const { uid } = fb.auth().currentUser;
  await db
    .collection('users').doc(uid)
    .set(user);
  sendSignUpAlert({ id: uid, ...user });
}

export const getUser = async () => {
  const userID = fb.auth().currentUser.uid;
  const doc = await db
    .collection('users').doc(userID)
    .get();
  const data = doc.data();
  return { id: userID, ...data };
}

export const isLoggedIn = () => {
  return !!fb.auth().currentUser;
}

export const findMe = async () => {
  const userID = fb.auth().currentUser.uid;
  const userRef = await db
    .collection('users').doc(userID)
    .get();
  const hallID = userRef.get('hall');
  const familyID = userRef.get('family');
  const familyRef = await db
    .collection('halls').doc(hallID)
    .collection('families').doc(familyID)
    .get();
  const family = { id: familyRef.id, ...familyRef.data() };
  return family;
}

export const sendPasswordResetEmail = async (email) => {
  if (!email) {
    const userID = fb.auth().currentUser.uid;
    const userRef = await db
    .collection('users').doc(userID)
    .get();
    email = userRef.get('email');
  }
  try {
    fb.auth().sendPasswordResetEmail(email);
  } catch (e) {
    console.error(e.message);
    throw e;
  }
}

export const isPendingOrAccepted = async () => {
  const userID = fb.auth().currentUser.uid;
  const doc = await db
    .collection('users').doc(userID)
    .get();
  const isAccepted = doc.get('isAccepted');
  const isPending= doc.get('isPending');
  return { isAccepted, isPending };
}